export function dataToForm(obj, isSell) {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }

  return Object.keys(obj).reduce((acc, key) => {
    acc[key.replace(/([A-Z])/g, '_$1').toLowerCase()] = obj[key];

    if (key === 'condition' && isSell && !Array.isArray(obj[key])) {
      acc[key] = [obj[key]];
    }

    return acc;
  }, {});
};


/**
 * The fields we already hold on a listing, in the shape `onProductSelected`
 * persists onto the slot's draft Request.
 *
 * `linked_listing_id` is the load-bearing one: PAYMENTS keys its visibility off
 * it, CONFIRM's "Finalise Order" resolves its nav target through it, and the
 * record-sale auto-finalise refuses to run without it. The other four are the
 * prefill that stops the rep re-typing their own listing.
 *
 * Defined once, and used by BOTH paths that attach a listing (picking one from
 * the Active Listings tab, and arriving in the flow with one in hand) so the
 * two can never drift.
 */
export const listingPrefill = (listing) => ({
  year: listing?.year || undefined,
  condition: listing?.condition ? [listing.condition] : undefined,
  delivery_set: listing?.box || undefined,
  price_expectation: listing?.price || undefined,
  linked_listing_id: listing?.id,
});
